import { queryOptions } from "@tanstack/react-query";
import { type Entitlements, entitlementsResponseSchema } from "../types";
import { enduserApi } from "./client";

export const entitlementsQueryOptions = () =>
  queryOptions<Entitlements>({
    queryKey: ["enduser", "entitlements"],
    queryFn: async () => {
      const { data } = await enduserApi.get<unknown>("/me/entitlements");
      return entitlementsResponseSchema.parse(data);
    },
  });
